import { iframeResizer } from 'iframe-resizer';
import React, { useRef } from "react";
import { HealthOfferPaymentOptionEnum, processQueryResult, useWsPayPaymentDetailsQuery } from "src/common";
import config from "src/config";
import { AppRoutes } from "src/pages/app";

export interface WsPayIframeProps {
  offerId: string;
  paymentType: string;
  paymentOption: HealthOfferPaymentOptionEnum;
  installments?: boolean;
}

export const WsPayIframe = ({ offerId, paymentType, paymentOption, installments = false }: WsPayIframeProps) => {
  const formRef = useRef<HTMLFormElement>(null);

  const { loading, error, data } = useWsPayPaymentDetailsQuery({
    variables: { offerId, paymentType, paymentOption, installments: 1 }, // Fake-ano da se uvijek šalje 1 jer nema razlike u cijeni
    fetchPolicy: 'cache-first',
    onCompleted: (result) => {
      processQueryResult(result);
      if (formRef.current) {
        formRef.current.submit();
        iframeResizer({ checkOrigin: false }, `#wsPay-iframe-${paymentOption}`);
      }
    }
  });

  if (loading) return null;
  if (error) return null;

  // Destrukturiranje podataka
  const { health } = data || {};
  const { checkoutHealthOfferWSPayPaymentDetails } = health || {};

  const myUrl = [config.REACT_APP_URL] || '';
  
  const hiddenFields = {
    ...checkoutHealthOfferWSPayPaymentDetails,
    PaymentPlan: installments ? undefined : '0000',  // Dok je gore fake-ano i uvijek se šalje installments = 1, checkoutHealthOfferWSPayPaymentDetails!.PaymentPlan je uvijek 0000
    ReturnURL: [myUrl, AppRoutes.CHECKOUT_SUCCESS.fullPath].join(''),
    CancelURL: [[myUrl, AppRoutes.CHECKOUT.fullPath].join(''), offerId].join('/'),
    ReturnErrorURL: [myUrl, AppRoutes.CHECKOUT_FAILURE.fullPath].join(''),
    Iframe: '1'
  };

  const renderHiddenFields = (fields: { [key: string]: string | undefined | null }) => Object.keys(fields).map((key) => {
    if (fields[key] === undefined || fields[key] === null) return null;
    return <input key={key} type="hidden" name={key} value={fields[key]!} />
  });

  return (
    <div>
      <form ref={formRef} name="pay" action={config.REACT_APP_WSPAY_URL} method="POST" target={`wsPay-iframe-${paymentOption}`}>
        {renderHiddenFields(hiddenFields)}
      </form>
      <iframe name={`wsPay-iframe-${paymentOption}`} id={`wsPay-iframe-${paymentOption}`} style={{ width: '100%', minHeight: '420px', border: 'none' }}></iframe>
    </div>
  );
};
